import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { GeoJSON as GeoLeaflet, FeatureGroup } from "leaflet";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { useLocation } from "react-router-dom";

import { GeoJSON } from "react-leaflet";

import { Marche } from "../../../services";

const ZaMarche = ({
  dsp,
  marcheList,
  zoom,
  MAX_ZOOM_DISPLAY_MARCHE,
  resetCoordonnees,
  setIsLoading,
  transmissionCoordonnees,
  enqueueSnackbar,
}) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const [contoursMarche, setContoursMarche] = useState([]);
  const [abortContours, setAbortContours] = useState(new AbortController());

  const displayZaMarche = () => {
    abortContours.abort();
    const abort = new AbortController();
    setAbortContours(abort);

    const listeCodeMarche = marcheList.map(marche => marche.codeReseau);
    if (listeCodeMarche.length > 0) {
      Marche.getMarchesZa(listeCodeMarche, abort)
        .then(async marchesZa => {
          const listeContoursMarcheTemp = marchesZa.features.map(marcheZa => ({
            ...marcheZa,
            style: {
              color: "grey",
              weight: 2,
              opacity: 1,
              fillColor: "grey",
              dashArray: "0",
              fillOpacity: 0,
            },
          }));

          /*
           ** Si aucune referenceImb n'est transmise en urlParams
           ** => Recentre la carte par rapport à l'ensemble des contours des marchés
           */
          if (!params.get("referenceImb")) {
            const target = new FeatureGroup(
              marchesZa.features.map(marcheZa => new GeoLeaflet(marcheZa)),
            ).getBounds();

            transmissionCoordonnees(target);
          }

          setContoursMarche(listeContoursMarcheTemp);
        })
        .catch(e => {
          if (e.code !== "ERR_CANCELED") {
            enqueueSnackbar(process.env.ERREUR_SERVEUR, {
              variant: "error",
              autoHideDuration: 6000,
            });
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (contoursMarche.length > 0) {
      const target = new FeatureGroup(
        contoursMarche.map(marcheZa => new GeoLeaflet(marcheZa)),
      ).getBounds();

      transmissionCoordonnees(target);
    }
  }, [resetCoordonnees]);

  useEffect(() => {
    displayZaMarche();
  }, []);

  return (
    <>
      {zoom <= MAX_ZOOM_DISPLAY_MARCHE &&
        contoursMarche.length > 0 &&
        contoursMarche.map(contours => (
          <GeoJSON key={contours.properties.codeReseau} data={contours} style={contours.style} />
        ))}
    </>
  );
};

ZaMarche.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
    secondaryMarches: propTypes.array,
  }).isRequired,
  marcheList: propTypes.array.isRequired,
  zoom: propTypes.number.isRequired,
  MAX_ZOOM_DISPLAY_MARCHE: propTypes.number.isRequired,
  resetCoordonnees: propTypes.bool.isRequired,
  setIsLoading: propTypes.func.isRequired,
  transmissionCoordonnees: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(ZaMarche);
